// Element_Map_Editor_Marker.jsx
import React, { useRef, useState, useEffect } from "react";
import { useTransformContext } from "react-zoom-pan-pinch";
import { useMapRenderer } from "../../Contexts/Context_MapRenderer";


export default function Element_Map_Marker({
    id,
    x,
    y,
    Label_Room,
    Label_State,
    State,
    onSave
}) {
    const { Map_HighlightedMarker, Room_Highlight, Information_Display } = useMapRenderer();
    return (
        <button
            id={id}
            Selected={Map_HighlightedMarker == id ? "Selected" : null}
            className="Element_Map_Marker"
            State={State}
            style={{
                position: "absolute",
                left: `${x}px`,
                top: `${y}px`,
                touchAction: "none",
                cursor: "grab",
                zIndex: 50
            }}
            onClick={() => {
                Room_Highlight(id, 4, 400);
                Information_Display("Room", id);
            }}
        >
            <p className="Element_Map_Marker_Label">{Label_Room}</p>
            <p className="Element_Map_Marker_State">{Label_State}</p>
        </button>
    );
}
